/* eslint-disable jsx-a11y/anchor-has-content */
import React from "react";

type Props = {
  active: string;
};

const NavItems = [
  "home",
  "about",
  "work",
  "skills",
  "testimonial",
  "process",
  "contact",
];

const NavigationDots = ({ active }: Props) => {
  return (
    <div className="app__navigation">
      {NavItems.map((item, index) => (
        <a
          href={`#${item}`}
          key={item + index}
          className="app__navigation-dot"
          style={active === item ? { backgroundColor: "#313BAC" } : {}}
        />
      ))}
    </div>
  );
};

export default NavigationDots;
